class MapBoundsStateSetterCtrl {

    constructor($scope, storeServ, mapHelperServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;
        this.mapHelperServ = mapHelperServ;

        this.ngOnInit();
    }

    ngOnInit() {
        this.idleListener = this.map.addListener('idle', this.onIdle.bind(this));

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    onIdle() {
        this.storeServ.dispatch({
            type: 'SET_MAP_BOUNDS',
            mapBounds: this.mapHelperServ.getLiteralBounds(this.map.getBounds())
        });
    }

    ngOnDestroy() {
        this.idleListener.remove();
        
        this.storeServ.getState().mapBounds && this.storeServ.dispatch({
            type: 'SET_MAP_BOUNDS',
            mapBounds: null
        });
    }
}

MapBoundsStateSetterCtrl.$inject = ['$scope', 'storeServ', 'mapHelperServ'];

var mapBoundsStateSetter = function() {
    return {
        restrict: 'E',
        scope: {},
        controller: MapBoundsStateSetterCtrl,
        controllerAs: 'vm',
        bindToController: {
        	map: '='
        }
    };
};

export default mapBoundsStateSetter;